module.exports = __webpack_public_path__ + "img/san-4.4c62e8ec.jpg";